import { z } from "zod";

/**
 * Shared email string schema used across features (sign-in, contacts, etc.).
 *
 * Validates that the value is a non-empty, well-formed email address.
 * Feature-specific form schemas should compose this into their own
 * `z.object()` wrappers rather than duplicating the validation rules.
 */
export const emailSchema = z
  .string()
  .min(1, "Email address is required")
  .check(z.email({ error: "Please enter a valid email address" }));
